import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SiteShell from "../components/layout/SiteShell";
import SEO from "../components/seo/SEO";
import HomeAnnouncementStrip from "../components/home/HomeAnnouncementStrip";
import Hero from "../components/Hero";
import HomeOrderSelector from "../components/home/HomeOrderSelector";
import HomeTrustRoutineStrip from "../components/home/HomeTrustRoutineStrip";
import HomeReviewsTeaser from "../components/home/HomeReviewsTeaser";
import HomeCommunityReward from "../components/home/HomeCommunityReward";
import HomeCustomHerbsNote from "../components/home/HomeCustomHerbsNote";
import HomeFaqPreview from "../components/home/HomeFaqPreview";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const id = (location.hash || "").replace("#", "");
    if (!id) return;
    const el = document.getElementById(id);
    if (el) {
      requestAnimationFrame(() => el.scrollIntoView({ behavior: "smooth", block: "start" }));
    }
  }, [location.hash]);

  return (
    <SiteShell theme="dark">
      <SEO
        title="Fresh sea moss for active routines | Moss Matrix"
        description="Gold and Purple Sea Moss Gel, freshly prepared and fridge-ready. Choose jar or pouch, pick your size, and keep your routine simple."
        path="/"
      />
      <main className="overflow-x-hidden">
        {/* Single marquee only — sits with hero as the top band */}
        <HomeAnnouncementStrip />
        <Hero />
        <HomeOrderSelector />
        <HomeTrustRoutineStrip />
        <HomeReviewsTeaser />
        <HomeCommunityReward />
        <HomeCustomHerbsNote />
        <HomeFaqPreview />
      </main>
    </SiteShell>
  );
};

export default HomePage;
